import { render, staticRenderFns } from "./zy.vue?vue&type=template&id=64ffd3d0&scoped=true"
import script from "./zy.vue?vue&type=script&lang=js"
export * from "./zy.vue?vue&type=script&lang=js"
import style0 from "./zy.vue?vue&type=style&index=0&id=64ffd3d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ffd3d0",
  null
  
)

export default component.exports